import wixWindow from 'wix-window';
import wixLocation from 'wix-location';

export function button4_click_1(event) {
	    if ($w('#firstName').value === 'flag-ch') {
            wixLocation.to('https://www.questair.co.il/flarid');
            }
        else if ($w('#firstName').value === 'Flag-ch') {
            wixLocation.to('https://www.questair.co.il/flarid');
            }
        else if ($w('#firstName').value === 'FLAG-CH') {
            wixLocation.to('https://www.questair.co.il/flarid');
            }
        
        else {
			wixWindow.openLightbox("No_Hanukka2018");
		}
	//Add your code for this event here: 
}